import { Button } from 'react-bootstrap'
import { useLogoutUserMutation } from '../../../../app/authApiSlice'

const FailedToLoadData = () => {
  const [logoutUser] = useLogoutUserMutation()

  const onClick = () => {
    logoutUser()
  }
  return (
    <>
      <h1 className="mb-4 fs-2 fw-semibold">Failed to load user data</h1>
      <p className="mb-4"> Please log out and try again.</p>
      <Button
        className="mt-2 px-5 rounded-3"
        variant="dark"
        onClick={onClick}
      >
        Log Out
      </Button>
    </>
  )
}

export default FailedToLoadData